import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Search } from "lucide-react";
import { api } from "../lib/api";
import { getServiceMeta } from "../lib/serviceIcons";

export default function Services() {
  const [services, setServices] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data.services));
  }, []);

  const filtered = services.filter((s) =>
    [s.name, s.category, s.tagline].join(" ").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="container-pad mx-auto max-w-[1400px] py-16 md:py-24" data-testid="services-page">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
        <div>
          <span className="label-eyebrow">All services</span>
          <h1 className="mt-3 text-4xl sm:text-5xl font-display font-medium tracking-tighter text-[#121C17]">{services.length} services. Zero friction.</h1>
          <p className="mt-4 text-[#5C6661] max-w-xl">Pick any, see the document checklist, upload your files and submit. We'll reply on WhatsApp within 10 minutes.</p>
        </div>
        <div className="relative w-full md:w-72">
          <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#5C6661]" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search services..."
            data-testid="services-search-input"
            className="w-full bg-white border border-[#E5E2DC] rounded-full pl-11 pr-4 py-3 text-sm focus:border-[#1E4D3B]"
          />
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="services-grid">
        {filtered.map((s) => {
          const { icon: Icon, accent, bgSolid } = getServiceMeta(s);
          return (
            <Link key={s.id} to={`/apply/${s.id}`} data-testid={`services-card-${s.id}`}
              className="bento-card p-7 group flex flex-col relative overflow-hidden">
              {/* Decorative corner blob */}
              <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full opacity-40 pointer-events-none" style={{ background: bgSolid }} />
              <div className="relative">
                <div className="flex items-start justify-between">
                  <div className="w-14 h-14 rounded-2xl grid place-items-center" style={{ background: bgSolid, color: accent }}>
                    <Icon size={26} />
                  </div>
                  <span className="label-eyebrow text-[10px]">{s.category}</span>
                </div>
                <h3 className="mt-5 text-2xl font-display font-medium text-[#121C17]">{s.name}</h3>
                <p className="mt-2 text-sm text-[#5C6661] flex-1">{s.tagline}</p>
                <div className="mt-6 pt-6 border-t border-[#E5E2DC] flex items-center justify-between">
                  <span className="text-xl font-display font-medium" style={{ color: accent }}>{s.price_label}</span>
                  <span className="rounded-full px-4 py-2 text-xs font-medium text-white inline-flex items-center gap-1 transition-transform group-hover:translate-x-0.5"
                    style={{ background: accent }}>
                    Apply <ArrowUpRight size={12} />
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
      {filtered.length === 0 && <p className="text-center text-[#5C6661] py-20">No services match "{q}".</p>}
    </div>
  );
}
